import Button from '@mui/material/Button';
import { useNavigate } from '@tanstack/react-location';
import type { TouristTaxTask } from '../../../../../packages/entities/Task';
import { usePropertyId } from '../../core/hooks/usePropertyId';
import useMarkTaskAsComplete from '../hooks/useMarkTaskAsComplete';
import WidgetBox from './WidgetBox';

const TaskWidget = ({
    task,
    onSuccess,
}: {
    task: TouristTaxTask;
    onSuccess?: () => void;
}) => {
    const navigate = useNavigate();
    const propertyId = usePropertyId();
    const markTaskAsComplete = useMarkTaskAsComplete();

    return (
        <WidgetBox>
            {task.description}
            <Button
                onClick={() => {
                    navigate({
                        to: propertyId
                            ? `/${propertyId}/financial/tax-payments`
                            : '/financial/tax-payments',
                    });
                }}
            >
                1. View tax payments
            </Button>
            <Button href="https://ohp-20.asp.lgov.hu/" target="_blank">
                3. Report and pay
            </Button>
            <Button
                onClick={() => {
                    (async () => {
                        await markTaskAsComplete(task.id);
                    })()
                        .then(() => {
                            onSuccess?.();
                        })
                        .catch(error => {
                            throw error;
                        });
                }}
                variant="contained"
                color="error"
            >
                Mark as done
            </Button>
        </WidgetBox>
    );
};

export default TaskWidget;
